export default __webpack_public_path__ + "static/media/1054.98cb9028.png";